// extracted by mini-css-extract-plugin
export default {"booksLayout":"BooksLayout_booksLayout__gmNpz","container":"BooksLayout_container__ZcBE3"};